import { configureStore } from '@reduxjs/toolkit'
import { api } from './api'
import uiReducer from './slices/uiSlice'
import filterReducer from './slices/filterSlice'
import searchReducer from './slices/searchSlice'
import facesReducer from './slices/facesSlice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    ui: uiReducer,
    filter: filterReducer,
    search: searchReducer,
    faces: facesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
